// Ciabatte / multi-interruttore Tuya: ogni presa diventa una voce separata "id:dp" ("Nome · presa 2"), oltre al dispositivo intero.
export function expandDevices(devices) {
  const out = [];
  for (const d of devices || []) {
    out.push(d);
    for (const ch of d.channels || []) out.push({ ...d, id: `${d.id}:${ch}`, name: `${d.name} · presa ${ch}`, channel: ch });
  }
  return out;
}
